import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const EnumArgControl = (t0) => {
  const $ = c(10);
  const {
    name,
    value,
    onChange,
    enumValues
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = (e) => onChange(e.target.value);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /* @__PURE__ */ jsx("option", { value: "", children: "—" });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== enumValues) {
    t3 = enumValues.map(_temp);
    $[3] = enumValues;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== name || $[6] !== t1 || $[7] !== t3 || $[8] !== value) {
    t4 = /* @__PURE__ */ jsxs("select", { "aria-label": name, value, onChange: t1, className: "graphiql-qb-arg-select", children: [
      t2,
      t3
    ] });
    $[5] = name;
    $[6] = t1;
    $[7] = t3;
    $[8] = value;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
function _temp(v) {
  return /* @__PURE__ */ jsx("option", { value: v, children: v }, v);
}
export {
  EnumArgControl
};
//# sourceMappingURL=enum-arg-control.js.map
